import * as PIXI from "pixi.js";
import { GameData } from "./GAMECODES/gamestate/gameData";
import { assetsToLoad } from "./GAMECODES/assetsName";
import { GameBaseSetup } from "../common/gameLib/BaseGame/GameBaseSetup";
import {
  collectSuccessCallBack,
  collectFailCallBack,
  threeSecondCheckBetSuccess,
  betFailCallBack,
  recoverSuccessCallBack,
  recoverFail,
  onPlayButtonDown,
  onKeyDown,
  replayFn,
  onKeyRelease,
} from "./GAMECODES/inGameFunction";
import { Environment } from "./GAMECODES/background/bg_environment";
import { SpinGame } from "./GAMECODES/GameSpinner/GameSpin";
import { BonusGameInfoUI } from "./GAMECODES/GameSpinner/bonusGameUI/BonusGameSpinsInfoUI";
import { createOptionPages } from "./GAMECODES/optionPages";
import {
  balSuccessCallBack,
  setVersionFromFile,
} from "../common/functions/Functions_General";
import "regenerator-runtime/runtime";

import { changeBid } from "../common/functions/Functions_GameBar";
import { NewWinAnimation } from "./GAMECODES/gameWin/winAnimation/winAnimationBuilder";
import { BuyBonusMain } from "../common/gameLib/Addons/Buy_in/buyInMain";
import { CommonData } from "../common/datastructures/gamestate/gameData";

let activeGameData = new GameData();
let gameBaseSetup: GameBaseSetup<CommonData>;
let mainGameScene = new PIXI.Container();
setVersionFromFile(activeGameData, InitSetup);

function InitSetup() {
  gameBaseSetup = new GameBaseSetup(activeGameData, assetsToLoad, setup);
  if (activeGameData.isMobile) {
    activeGameData.gameScale = 260 / 213;
  }
  mainGameScene = gameBaseSetup.getGameScene();
  let gameContainer = new PIXI.Container();
  gameBaseSetup.setGameContainer(gameContainer);
}
function setup() {
  //-setup new winanimation
  activeGameData.newWinAnimation = new NewWinAnimation(
    activeGameData.coinsContainer,
    activeGameData
  );
  activeGameData.newWinAnimation.setIncludeSmallAnimations(true);

  //--example use
  // activeGameData.newWinAnimation.displayWin(200000,1000)    ;
  activeGameData.winAnimation;
  gameBaseSetup.setMainGame(SpinGame); //give in parameter the main game;   it will auto create game menu bar
  activeGameData.collectSuccess = (data: any): void => {
    collectSuccessCallBack(data, activeGameData, gameBaseSetup);
  };
  activeGameData.collectFail = (errorMsg: string): void => {
    activeGameData.errorTypeToDisplay = errorMsg;
    collectFailCallBack(activeGameData, gameBaseSetup);
  };
  activeGameData.betSuccess = (data: any): void => {
    threeSecondCheckBetSuccess(data, activeGameData, gameBaseSetup);
  };
  activeGameData.betFail = (errorMsg: string): void => {
    activeGameData.errorTypeToDisplay = errorMsg;
    betFailCallBack(activeGameData, gameBaseSetup);
  };
  activeGameData.balSuccessUpdate = (data: any): void => {
    balSuccessCallBack(data, activeGameData);
  };
  activeGameData.recoverSuccess = (data: any): void => {
    recoverSuccessCallBack(data, activeGameData);
  };
  activeGameData.recoverFail = (errorMsg: string): void => {
    activeGameData.errorTypeToDisplay = errorMsg;
    recoverFail(activeGameData, gameBaseSetup);
  };
  activeGameData.playFunction = (): void => {
    onPlayButtonDown(activeGameData);
  };
  activeGameData.keyPress = onKeyDown;
  gameBaseSetup.setSky("game_BG.png"); //if not used ,fallbacks to predefined background color on background
  gameBaseSetup.setEnvironment(Environment); //define an environment for game with all the degcorations on backgrounds etc, that doesnt involve Background
  let logoName = "LOGOS_english.png";
  gameBaseSetup.setLogo(logoName, true);
  activeGameData.bonusGameInfos = new BonusGameInfoUI(
    mainGameScene,
    activeGameData.size,
    activeGameData
  );
  activeGameData.gameBar.setPlayBtnFunction(activeGameData.playFunction);
  // activeGameData.replay.enableTestReplayLocally(true);
  activeGameData.mainGame.createHoldToSkipBtn(); ///hold to skip expand animation during bonus game

  //--new listener fo the hold to skip btn
  document.addEventListener("keyup", (key: KeyboardEvent) => {
    onKeyRelease(key, activeGameData);
  });

  //   activeGameData.loginResponse.gameSettings.buyBonusFactor=100;
  //   activeGameData.loginResponse.gameSettings.buyBonusEnabled=true;
  //   activeGameData.loginResponse.gameSettings.defaultAllowedInputActions=['BET','BUY_BONUS'];
  //--

  if (activeGameData.loginResponse.gameSettings.buyBonusFactor != undefined) {
    gameBaseSetup.setOptionPage(9); //(9);//create Option pages with buy bonus details
  } else {
    gameBaseSetup.setOptionPage(8); //create Option pages
  }

  createOptionPages(activeGameData);
  changeBid(activeGameData);
  // activeGameData.skipGame = (): void => { skipGame(activeGameData) };
  activeGameData.replayFn = (): void => {
    replayFn(activeGameData);
  };
  let logo = gameBaseSetup.getLogo();

  if (activeGameData.InspectReplay) {
    activeGameData.replay.openReplay();
    // activeGameData.replay.replayModeRequest();
  }

  if (activeGameData.isEmulation) {
    activeGameData.emulationMode.open();
  }

  //--extra BUY IN

  activeGameData.BuyBonus = new BuyBonusMain(
    activeGameData.bonusBuyContainer,
    activeGameData,
    1
  );
  activeGameData.BuyBonus.setCardImageAllCards("buyInPageTalesOfTime.png");
  activeGameData.BuyBonus.clear();
  activeGameData.BuyBonusIsClientSideReady = true;

  if (
    activeGameData.loginResponse.activeGame == false &&
    activeGameData.loginResponse.gameSettings.buyBonusFactor != undefined
  ) {
    activeGameData.BuyBonus.loadDefault();
  }

  ///------------ADJUSTMENT for some game elements to realign

  //-mod the gamble game
  activeGameData.gambleGame.setStyleCardBackTexture("cardsEgypt");

  activeGameData.gambleGame.setStyleSpinningImage("lensFlare_Sparks2", 1.8, 1);

  activeGameData.gambleGame.setNewSoundTick(
    "Epic_Button_Click_1.mp3",
    0,
    1733,
    0.65
  );
  activeGameData.gambleGame.setNewSoundLose("Egyptian Game Over.mp3", 0, 2452);
  activeGameData.gambleGame.setNewSoundWin("Egyptian Win.mp3", 0, 4057);

  let gambleC = activeGameData.gambleGame.getBgImage();
  gambleC.width = 1370;
  gambleC.height = 845;
  activeGameData.gambleGame.setPositiontoCenter();
  gambleC.y -= 40;
  //  gambleC.x+=500;

  // let gambleGameParent=activeGameData.gambleGame.getParent();

  if (activeGameData.isMobile) {
    // gambleC.y-=40;
    activeGameData.gameOption.setPageNewY(-50);

    logo.setMobilePosition([activeGameData.size[0] / 2, 95]);
    logo.setMobileScale(0.7);

    //-logobg

    activeGameData.logo.getLogoBG().width = 1370;
    activeGameData.logo.getLogoBG().height = 840;
    activeGameData.logo.getLogoBG().y -= 15;
    activeGameData.logo.getLogoBG().x = activeGameData.size[0] / 2;

    // activeGameData.gameOption.
  } else {
    logo.setDesktopScale(0.75);
    logo.setDesktopPosition([activeGameData.size[0] / 2, 35]);
    //--option
    activeGameData.gameOption.setDesktopHeight(840);
    activeGameData.gameOption.setDesktopWidth(1370);
    activeGameData.gameOption.setOffsetY(-26);
    activeGameData.gameOption.setPageNewY(-150);
  }

  // activeGameData.gambleGame.set
  // activeGameData.gambleGame.startGamble(true);

  // let tes= new smallWinAnimation(activeGameData.gameScene);
  // tes.setPosition([activeGameData.size[0]/2,100]);
  // tes.playShockWave(true);

  // activeGameData.newWinAnimation.displayWin(1000,1)

  // let tilingtest= new tilingAnimatedSprite(activeGameData.gameScene,"symbolTutoPast",0,46,[1920,1080]);
  // tilingtest.setAnimationSpeed(30);
  // tilingtest.getTileSprite().tileScale.set(.1)
  // // tilingtest.getTileSprite().tilePosition.set(50,100)
  // tilingtest.start();

  // let test= new BonusSymbolPickerBookAnimation(activeGameData.coinsContainer,activeGameData);
  // test.startNewBonusAnimation(1);

  // activeGameData.newWinAnimation.displayWin(4000,1)
}
// @ts-ignore
if (module.hot) {
  module.hot.accept();
  module.hot.dispose(function() {
    window.location.reload();
  });
}
